import {http, onSuccess, onFail, onSuccessWithHeaders} from './http';

export const eventPollAnswerClick = (eventKey, pollId, answers, authorizationRequired) => {
    const data = {
        answers,
        anonymous: !authorizationRequired,
    };

    return http.post(`/api/player/event/${eventKey}/poll/${pollId}/standard/answer`, data)
        .then(onSuccessWithHeaders, onFail);
}

export const eventPollOpenAnswers = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/poll/open/answer`, data)
        .then(onSuccessWithHeaders, onFail);

export const eventPollRatingAnswers = (eventKey, pollId, data) =>
    http.post(`/api/player/event/${eventKey}/poll/${pollId}/rating/answer`, data)
        .then(onSuccessWithHeaders, onFail);

export const eventPollGet = (eventKey) =>
    http.get(`/api/player/event/${eventKey}/poll`)
        .then(onSuccess, onFail);
